module.exports = __webpack_public_path__ + "static/assets/6cba5a4b68e3a1b226e2f95393d04e29.png";